import React from 'react'
import { Typography } from '../../components/Typography'
import { TextContainer, Container, Content, IconContainer, Icon, FooterContainer, Footer } from './styles'
import { Header } from '../../components/Header'

export default function UnsubscribeSuccess() {
  return (
    <Container>
      <Header/>
      <Content>
        <TextContainer>
          <Typography size="large" weight="bold" color="green" >Documentos enviados com sucesso!</Typography>
          <Typography>Seus documentos foram enviados para a análise e você terá a resposta em até 2 (dois) dias úteis.</Typography>
        </TextContainer>
        <IconContainer>
          <Icon></Icon>
        </IconContainer>
      </Content>    
      <FooterContainer>
        <Footer>
          <div>
            <Typography color="primary" weight="bold">
              CREFISA S.A. CRÉDITO FINANCIAMENTO E INVESTIMENTOS
            </Typography>
            <Typography color="textLight" size="small">CNPJ: 60.779.196/0001-96</Typography>
            <Typography size="small">Endereço: Rua Canadá, 387 - Jd. América, São Paulo - SP CEP: 01.436-900*</Typography>
          </div>
          <div>
            <Typography color="primary" weight="bold">BANCO CREFISA S.A.</Typography>
            <Typography color="textLight" size="small">CNPJ: 61.033.106/0001-86</Typography>
            <Typography size="small">Endereço: Rua Canadá, 390 - Jd. América, São Paulo - SP CEP: 01.436-900*</Typography>
          </div>
          <Typography size="small">*Nesses endereços, não há atendimento a clientes. Encontre nossos Pontos de Atendimento clicando aqui.</Typography>
        </Footer>
      </FooterContainer>
    </Container>
  )
}